import { ucBackstageUrl } from '@/config/project-config'
import { API } from '@/util/api'
import store from '../store'
import md5 from "js-md5";
// 日期操作工作类方法
const fileutil = {
  // cfs服务器文件上传地址
  cfsUploadFileAction: ucBackstageUrl + "/" + API.uploadFile,
  // cfs服务器文件下载地址
  cfsUploadFileDownLoad: ucBackstageUrl + "/" + API.downloadFile,
  // 文件格式
  limitFileSuffix: '.rar .zip .doc .docx .xls .xlsx .ppt .pptx .pdf .jpg .png .jpeg .bmp .cdr .ai .psd .dwt .dwg .dws .dxf .tif .tiff',
  // 文件格式
  limitFileSuffixOnlyImg: '.jpg .png .jpeg .bmp',
  // 文件大小限制 单位M
  limitFileSize: '20', // 单位M大小限制
  // 文件上传数量(填负数)
  limitFileNum: '-1',
  // 文件校验
  beforeUpload: function (form, file) {
    const fileSuffix = file.name.substr(file.name.lastIndexOf('.'))
    const isLtFileSuffix = this.limitFileSuffix.indexOf(fileSuffix) > -1
    const isLtSize = file.size / 1024 / 1024 <= this.limitFileSize
    if (!isLtSize || !isLtFileSuffix) {
      form.$message.error('请上传 ' + this.limitFileSize + 'MB 以内的文件，支持扩展名：' + this.limitFileSuffix + '!')
    }
    return isLtFileSuffix && isLtSize
  },

  // 文件校验
  beforeUploadOnlyImg: function (form, file) {
    var isLtFileSuffix = null
    var isLtSize = null
    try {
      const fileSuffix = file.name.substr(file.name.lastIndexOf('.'))
      isLtFileSuffix = this.limitFileSuffixOnlyImg.indexOf(fileSuffix) > -1
      isLtSize = file.size / 1024 / 1024 <= this.limitFileSize
      if (!isLtSize || !isLtFileSuffix) {
        form.$message.error('请上传 ' + this.limitFileSize + 'MB 以内的图片，支持扩展名：' + this.limitFileSuffixOnlyImg + '!')
      }
    } catch (e) {
      form.$message.error('请上传 ' + this.limitFileSize + 'MB 以内的图片，支持扩展名：' + this.limitFileSuffixOnlyImg + '!')
      return false
    }
    return isLtFileSuffix && isLtSize
  },
  // 下载文件
  cfsDownload: function (form, filePath, fileName) {
    console.log("==========="+filePath)
    console.log("==========="+fileName)
    let fileUrl = ''
    // 判断网络路径
    if (filePath.indexOf('http') > -1) {
      const groupIndex = filePath.indexOf('/group')
      if (groupIndex > -1) {
        fileUrl = this.cfsUploadFileDownLoad + '?filePath=' + filePath.substr(groupIndex + 1)
      } else {
        fileUrl =	filePath
      }
    } else {
      fileUrl = this.cfsUploadFileDownLoad + '?filePath=' + filePath
    }
    if (!fileName) {
      // const fileName = decodeURI(downloadUrl.substr(downloadUrl.lastIndexOf('/') + 1))
      fileName = fileUrl.substr(fileUrl.lastIndexOf('/') + 1)
    }
    var xmlhttp = new XMLHttpRequest() // 用于在后台与服务器交换数据
    xmlhttp.open('GET', fileUrl, true) // 语法  open(method,url,async)
    let timestamp = new Date().getTime() + '';
    let radom = Math.random() + '';
    let str = timestamp + radom + '1'
    let token = md5(str)
    xmlhttp.setRequestHeader("timestamp", timestamp);
    xmlhttp.setRequestHeader("radom", radom);
    xmlhttp.setRequestHeader("crossToken", token);
    xmlhttp.setRequestHeader("crossType", 1);
    xmlhttp.responseType = 'blob' // 请求返回的数据类型
    xmlhttp.onload = function () { // 处理返回的数据
      // console.log('---返回信息---', this)
      if (this.status == 200) {
        var blob = this.response
        var a = document.createElement('a')
        a.href = window.URL.createObjectURL(blob) // 文件地址
        a.download = fileName // 下载时 文件命名    如果没有默认是下载的文件的路径
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } else {
        form.$message.error('文件下载失败')
      }
    }
    xmlhttp.send() // 用于发送http请求
  }
}

export { fileutil }



// WEBPACK FOOTER //
// ./src/util/fileutil.js